var $477af2994bdb8c65$exports = {};
$477af2994bdb8c65$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xfdber farieb`,
    "colorSwatch": `vzorkovn\xedk farieb`,
    "transparent": `transparentn\xfd`,
    "twoDimensionalSlider": `2D jazdec`
};


export {$477af2994bdb8c65$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
